<template>
  <section class="section-profile">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <router-link :to="{name:'Profile'}" class="arrow-menu-profile">
            <i class="fas fa-arrow-left mr-10"></i>
            {{ $t("profile.back") }}
          </router-link>
        </div>
        <div class="col-lg-2 col-1"></div>
        <div class="col-lg-8 col-10">
          <div align="center">
            <div class="profile-avatar">
              <ImageUploader
                  id="input-avatar"
                  :quality="0.7"
                  outputFormat="verbose"
                  :preview=false
                  :capture="false"
                  accept="image/*"
                  @change="handlegImgAvatar"
              ></ImageUploader>
              <img :src="user.avatar_url" @click="changeAvatar"/>
            </div>
            <span class="avatar-faces" :class="avatarFacesColor">
              {{ $t(avatarFaces) }}
            </span>
            <h2 class="title">
              {{ $t("profile.yourData") }}
            </h2>
            <div class="row">
              <div class="col-lg-3"></div>
              <div class="col-lg-6">
                <form>
                  <div class="form-group">
                    <input type="email"
                      class="form-control input_contact"
                      disabled v-model="user.email"
                      placeholder="Email" />
                  </div>
                  <div class="form-group">
                    <input type="text"
                      class="form-control input_contact"
                      :placeholder="$t('profile.name')"
                      v-model="user.first_name" />
                  </div>
                  <div class="form-group">
                    <input type="text"
                      class="form-control input_contact"
                      :placeholder="$t('profile.middleName')"
                      v-model="user.middle_name" />
                  </div>
                  <div class="form-group">
                    <input type="text"
                      class="form-control input_contact"
                      :placeholder="$t('profile.lastName')"
                      v-model="user.last_name" />
                  </div>
                  <div class="form-group">
                    <input type="password"
                      class="form-control input_contact"
                      :placeholder="$t('profile.password')"
                      v-model="user.password" />
                    <div align="left" class="ml-10">
                      <span class="text-grey">{{$t("profile.minimumCharacters")}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <input type="password"
                      class="form-control input_contact"
                      v-model="user.password_confirmation"
                      :placeholder="$t('profile.passwordConfirmation')" />
                  </div>
                  <button type="button" @click="create" class="button-profile mt-20">
                    {{ $t("profile.save") }}
                  </button>
                </form>
              </div>
            </div>
            <div class="col-lg-3"></div>
          </div>
        </div>
        <div class="col-lg-2 col-1">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import User from "../../models/User";

export default {
  name: "MyData",
  data() {
    return {
      user: new User(),
      params: {
        first_name: "",
        last_name: "",
        middle_name: "",
      },
    }
  },
  mounted() {
    this.$user.fetch().then((request) => {
      this.$user = new User(request.response.data.user)
      this.user = this.$user
      this.loaded = true
      this.$root.$emit('setUser', this.user)
    }).catch((error) => {
      this.loaded = true
    })
  },
  methods: {
    async handlegImgAvatar(e) {
      const imgUser = {avatar: e.dataUrl}
      let user = new User()
      this.$root.$emit("showLoader")

       await user.updateAvatar(imgUser).then((response) => {
          this.$alertify.success(this.$t("profile.editUser"))
          this.$user = new User(response.response.data.user)
          this.user = this.$user
          
          this.$root.$emit("hideLoader")
          this.$root.$emit('setUser', this.user)
        }).catch((e) => {
          this.$root.$emit("hideLoader")
          this.$alertify.error(e.response.response.data.errors)
      })
    },
    changeAvatar() {
      this.$el.querySelector("#input-avatar").click()
    },
    async create() {
      this.$root.$emit("showLoader")
      if (this.user.password) {
        if (this.user.password !== this.user.password_confirmation) {
          this.$alertify.error('Los password no Coinciden')
          return
        } else {
          this.params.password = this.user.password;
          this.params.password_confirmation = this.user.password_confirmation;
        }
      }
      this.params.first_name = this.user.first_name;
      this.params.last_name = this.user.last_name;
      this.params.middle_name = this.user.middle_name;

      let user = new User()
      user.update(this.params).then((response) => {
        this.$user = new User(response.response.data.user)
        this.user = this.$user
        this.$alertify.success(this.$t("profile.editUser"))
        this.$root.$emit("hideLoader")
        this.$root.$emit('setUser', this.user)
      }).catch((e) => {
        this.$root.$emit("hideLoader")
        this.$alertify.error(e.response.response.data.errors)
      })
    }
  },
  computed: {
    avatarFaces() {
      let message = "";

      if(this.user.face == 0) {
        message = "profile.faces.empty";
      } else if(this.user.face == 1) {
        message = "profile.faces.success";
      } else {
        message = "profile.faces.moreThanOne";
      }
      return message;
    },
    avatarFacesColor() {
      return this.user.face == 1 ? "avatar-success" : "avatar-error";
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  .section-profile {
    margin-top: 40px;
    margin-bottom: 80px
  }

  .text-grey {
    color: grey
  }

  .arrow-menu-profile {
    text-align: left;
    text-decoration: none;
    font-family: $font-light;
    font-size: 16px;
    color: #003B4D
  }

  .avatar-faces {
    font-size: 12px;
    width: 400px;
    display: block;
    padding: 15px;
  }

  .avatar-success {
    color: #009323;
  }

  .avatar-error {
    color: red;
  }
</style>
